/**
 * LastScanLabel — Subtle "Dernier scan" indicator
 * Luxury design: DM Sans italic, colors.textLight, framer-motion fade-in
 */
import React from 'react';
import { Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { colors } from '../../styles/colors';

function formatRelativeTime(date) {
  if (!date) return null;

  const now = new Date();
  const diff = now - date;
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  // Format time as HHhMM
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const timeStr = `${hh}h${mm}`;

  if (days === 0 && hours < 1) {
    if (minutes < 2) return 'a l\'instant';
    return `il y a ${minutes} min`;
  }
  if (days === 0) {
    return `aujourd'hui, ${timeStr}`;
  }
  if (days === 1) {
    return `hier, ${timeStr}`;
  }
  return `il y a ${days} jours`;
}

function LastScanLabel({ timestamp, dark = false }) {
  const label = formatRelativeTime(timestamp);
  if (!label) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <Typography
        aria-live="polite"
        sx={{
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '0.72rem',
          fontStyle: 'italic',
          color: dark ? 'rgba(250,247,242,0.4)' : colors.textLight,
          mt: 0.5,
          display: { xs: 'none', sm: 'block' },
        }}
      >
        Dernier scan : {label}
      </Typography>
    </motion.div>
  );
}

export default LastScanLabel;
